"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuthResource = void 0;
const OAuthResource = exports.OAuthResource = {
  modelYear: "modelYear",
  safetyCampaign: "safetyCampaign",
  manuals: "manuals",
  masterPreferences: "masterPreferences",
  optCodes: "optCodes",
  maintenanceScheduleDmy: "maintenanceScheduleDmy",
  maintenanceschedulevin: "maintenanceschedulevin",
  maintenanceScheduleEtd: "maintenanceScheduleEtd",
  vehicleSpecs: "vehicleSpecs"
};